import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

// Logo-based brand colors
const brandGreen = '#62A052'; // primary
const brandGreenDark = '#3E7A3F';
const brandGreenLight = '#A8CDA3';

const brandRed = '#9B3A34';   // secondary
const brandRedDark = '#6E241F';
const brandRedLight = '#C96B63';

export default {
  black,
  white,

  // BRAND
  primary: {
    contrastText: white,
    dark: brandGreenDark,
    main: brandGreen,
    light: brandGreenLight
  },
  secondary: {
    contrastText: white,
    dark: brandRedDark,
    main: brandRed,
    light: brandRedLight
  },

  // STATUS (ongewijzigd, Material kleuren)
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },

  // TYPO / SURFACE
  text: {
    primary: '#2F251B',       // donkerbruin (beter contrast)
    secondary: '#5B4C42',     // iets lichter bruin
    link: brandGreen          // links in merk-groen
  },
  background: {
    default: '#F7F9F6',       // zachte, frisse achtergrond
    paper: white
  },

  icon: colors.blueGrey[500],
  divider: '#E0E6DB'          // subtiele groengrijze divider
};

// export default {
//   black,
//   white,
//   primary: {
//     contrastText: white,
//     dark: colors.indigo[900],
//     main: colors.indigo[500],
//     light: colors.indigo[100]
//   },
//   success: {
//     contrastText: white,
//     dark: colors.green[900],
//     main: colors.green[600],
//     light: colors.green[400]
//   },
//   info: {
//     contrastText: white,
//     dark: colors.blue[900],
//     main: colors.blue[600],
//     light: colors.blue[400]
//   },
//   warning: {
//     contrastText: white,
//     dark: colors.orange[900],
//     main: colors.orange[600],
//     light: colors.orange[400]
//   },
//   error: {
//     contrastText: white,
//     dark: colors.red[900],
//     main: colors.red[600],
//     light: colors.red[400]
//   },
//   text: {
//     primary: colors.blueGrey[900],
//     secondary: colors.blueGrey[600],
//     link: colors.blue[600]
//   },
//   background: {
//     default: '#F4F6F8',
//     paper: white
//   },
//   icon: colors.blueGrey[600],
//   divider: colors.grey[200]
// };
